import { createSlice } from "@reduxjs/toolkit";

export const generalDocumentSlice = createSlice({
  name: "generalDocumentSlice",
  initialState: {
    generalDocumentData : {
      orgId: '',
      templateUUID: '',
      documentUUID: '',
      signatureFlow: '',
      iv: '',
      token: ''
    },
    pageDimensions: {
      width: 595.304,
      height: 841.889,
    }
  },
  reducers: {
    setGeneralDocumentData: (currentState, action) => {
      const { generalDocumentData } = action.payload;
      currentState.generalDocumentData = generalDocumentData;
    },
    setPageDimensions: (currentState, action) => {
      currentState.pageDimensions = action.payload;
    }
  },
});

// Action creators are generated for each case reducer function
export const { setGeneralDocumentData, setPageDimensions } = generalDocumentSlice.actions;

export default generalDocumentSlice.reducer;